import { gsap } from 'gsap'

const LanguagePicker = {
  controller: null,
  cleanupAnimation: null,

  init() {
    if (this.controller) return

    const picker = document.querySelector('[data-language-picker]')
    const toggle = picker?.querySelector('summary')
    const list = picker?.querySelector('.language-picker-list')
    if (!toggle || !list) return

    this.controller = new AbortController()
    const { signal } = this.controller
    const items = Array.from(list.children)
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    let isOpen = picker.open

    const finishClose = () => {
      if (!isOpen) picker.open = false
    }

    const animation = gsap
      .timeline({ paused: true, onReverseComplete: finishClose })
      .fromTo(list, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.24, ease: 'power2.out' })
      .fromTo(items, { opacity: 0, y: 4 }, { opacity: 1, y: 0, duration: 0.18, stagger: 0.025, ease: 'power2.out' }, 0.04)

    animation.progress(isOpen ? 1 : 0).pause()

    const setOpen = open => {
      if (open === isOpen) return

      isOpen = open
      list.inert = !open
      if (open) picker.open = true

      if (reducedMotion.matches) {
        animation.progress(open ? 1 : 0).pause()
        finishClose()
        return
      }

      animation.timeScale(open ? 1 : 1.5)
      if (open) {
        animation.play()
      } else if (animation.progress() === 0) {
        finishClose()
      } else {
        animation.reverse()
      }
    }

    toggle.addEventListener(
      'click',
      event => {
        event.preventDefault()
        setOpen(!isOpen)
      },
      { signal }
    )

    document.addEventListener(
      'click',
      event => {
        if (!picker.contains(event.target)) setOpen(false)
      },
      { signal }
    )

    document.addEventListener(
      'keydown',
      event => {
        if (event.key !== 'Escape' || !isOpen) return

        toggle.focus()
        setOpen(false)
      },
      { signal }
    )

    // Safari can blur the summary before a language link receives its click.
    document.addEventListener(
      'focusin',
      event => {
        if (!picker.contains(event.target)) setOpen(false)
      },
      { signal }
    )

    reducedMotion.addEventListener(
      'change',
      () => {
        animation.progress(isOpen ? 1 : 0).pause()
        finishClose()
      },
      { signal }
    )

    this.cleanupAnimation = () => {
      animation.kill()
      gsap.set([list, ...items], { clearProps: 'opacity,transform' })
      picker.open = false
      list.inert = false
    }
  },

  destroy() {
    this.controller?.abort()
    this.controller = null
    this.cleanupAnimation?.()
    this.cleanupAnimation = null
  }
}

export default LanguagePicker
